import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { SplashScreenService, SplashState } from './splash-screen.service';
import { UserPreferenceService } from 'src/app/features/services/users/user_profile/user-preference.services';

@Component({
    selector: 'app-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss'],
    standalone: false
})
export class SplashScreenComponent implements OnInit {
  @ViewChild('splashScreen', { static: true }) splashScreen!: ElementRef;
  currentTheme = document.documentElement.classList.contains('dark-theme') ? 'dark-theme' : 'light-theme';
  readonly state$ = this.splashScreenService.state$;

  constructor(
    private readonly el: ElementRef,
    private readonly splashScreenService: SplashScreenService,
    private readonly cd: ChangeDetectorRef,
    private readonly userPreferenceService: UserPreferenceService
  ) {}

  ngOnInit(): void {

    const persistedMode = this.splashScreenService.consumePersistedMode();
    if (persistedMode) {
      this.splashScreenService.show(persistedMode);
    }

    this.userPreferenceService.splashcurrentUserPreferences$.subscribe((value) => {
      this.cd.detectChanges();
      if (value != null && value != undefined) {
       const localTheme = String(value.theme ?? '').toLowerCase();
         if(localTheme=='system' || localTheme=='default' || !localTheme){
         const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
         let systemTheme = prefersDark.matches ? "dark-theme" : "light-theme";
         this.currentTheme=systemTheme;
         } else {
         this.currentTheme = localTheme.includes('dark') ? 'dark-theme' : 'light-theme';
        }
      }
    });
    this.splashScreenService.init(this.splashScreen);
  }

  getStatus(state: SplashState): string {
    if (state.message) return state.message;
    if (state.mode === 'login') return 'Signing in...';
    if (state.mode === 'logout') return 'Signing out...';
    return '';
  }

  get isDarkTheme(): boolean {
    return this.currentTheme === 'dark-theme' || this.currentTheme === 'dark';
  }

}
